"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarItemType = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var react_1 = require("@iconify/react");
var react_2 = require("@heroui/react");
var react_router_dom_1 = require("react-router-dom");
var SidebarItemType;
(function (SidebarItemType) {
    SidebarItemType["Nest"] = "nest";
})(SidebarItemType || (exports.SidebarItemType = SidebarItemType = {}));
var Sidebar = React.forwardRef(function (_a, ref) {
    var items = _a.items, isCompact = _a.isCompact, defaultSelectedKey = _a.defaultSelectedKey, onSelect = _a.onSelect, hideEndContent = _a.hideEndContent, iconClassName = _a.iconClassName, className = _a.className, currentRoute = _a.currentRoute;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = React.useState(defaultSelectedKey), selected = _b[0], setSelected = _b[1];
    var renderIcon = function (item) { var _a; return item.icon ? (0, jsx_runtime_1.jsx)(react_1.Icon, { className: (0, react_2.cn)("text-white", iconClassName), icon: item.icon, width: 24 }) : (_a = item.startContent) !== null && _a !== void 0 ? _a : null; };
    var handleSelect = function (item) {
        setSelected(item.key);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.key);
        if (item.href) {
            navigate("".concat(currentRoute !== null && currentRoute !== void 0 ? currentRoute : "").concat(item.href));
        }
    };
    var renderLeaf = function (item) {
        var _a;
        var isSelected = selected === item.key;
        var row = ((0, jsx_runtime_1.jsxs)("a", { href: item.href ? "".concat(currentRoute !== null && currentRoute !== void 0 ? currentRoute : "").concat(item.href) : undefined, onClick: function (event) {
                event.preventDefault();
                handleSelect(item);
            }, className: (0, react_2.cn)("group flex h-11 min-h-11 items-center gap-2 rounded-lg px-3 text-sm font-medium text-white no-underline cursor-pointer", isSelected ? "bg-white/20 font-semibold" : "hover:bg-white/10", isCompact && "h-11 w-11 justify-center gap-0 p-0", item.className), children: [renderIcon(item), !isCompact && (0, jsx_runtime_1.jsx)("span", { className: "flex-1 truncate", children: item.title }), !isCompact && !hideEndContent && ((_a = item.endContent) !== null && _a !== void 0 ? _a : null)] }, item.key));
        if (isCompact) {
            return ((0, jsx_runtime_1.jsxs)(react_2.Tooltip, { children: [(0, jsx_runtime_1.jsx)(react_2.Tooltip.Trigger, { children: row }), (0, jsx_runtime_1.jsx)(react_2.Tooltip.Content, { placement: "right", children: item.title })] }, item.key));
        }
        return row;
    };
    var renderNest = function (item) {
        var _a;
        if (isCompact) {
            return renderLeaf(item);
        }
        return ((0, jsx_runtime_1.jsx)(react_2.Accordion, { "aria-label": "accordion-".concat(item.key), className: "p-0", children: (0, jsx_runtime_1.jsxs)(react_2.Accordion.Item, { id: item.key, className: "after:hidden", children: [(0, jsx_runtime_1.jsx)(react_2.Accordion.Heading, { children: (0, jsx_runtime_1.jsxs)(react_2.Accordion.Trigger, { className: "h-11 rounded-lg px-3 py-0 hover:bg-white/10", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-1 items-center gap-2", children: [renderIcon(item), (0, jsx_runtime_1.jsx)("span", { className: "text-sm font-medium text-white", children: item.title })] }), (0, jsx_runtime_1.jsx)(react_2.Accordion.Indicator, {})] }) }), (0, jsx_runtime_1.jsx)(react_2.Accordion.Panel, { children: (0, jsx_runtime_1.jsx)(react_2.Accordion.Body, { className: "py-0 pl-4", children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-1 border-l border-default pl-2", children: ((_a = item.items) !== null && _a !== void 0 ? _a : []).map(function (subItem) { return renderLeaf(subItem); }) }) }) })] }) }, item.key));
    };
    var renderItem = function (item) {
        var isNest = item.items && item.items.length > 0 && item.type === SidebarItemType.Nest;
        if (isNest) {
            return renderNest(item);
        }
        if (item.items && item.items.length > 0) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [!isCompact && (0, jsx_runtime_1.jsx)("span", { className: "px-3 pt-2 text-xs font-medium text-white/60", children: item.title }), item.items.map(function (subItem) { return renderItem(subItem); })] }, item.key));
        }
        return renderLeaf(item);
    };
    return ((0, jsx_runtime_1.jsx)("nav", { ref: ref, "aria-label": "sidebar", className: (0, react_2.cn)("flex flex-col gap-1", isCompact && "items-center", className), children: items.map(function (item) { return renderItem(item); }) }));
});
Sidebar.displayName = "Sidebar";
exports.default = Sidebar;
